import React, { Component } from "react";
import axios from "axios";
import { withRouter } from "react-router";
import Layout from "../Layout/Layout";
import Navbar from "../../../Components/NavBar/Navbar";
import Sidebar from "../../../Components/Sidebar/sidebar";
import ResponsiveSidebar from "../../../Components/Sidebar/Responsive/SideBar";
import { SIDE_NAV_ITEMS } from "../../../api-constant";
import WorksheetDetails from "./WorksheetDetails";
import ResponsiveWorksheetDetails from "./Responsive/Worksheet-Details";
import GoalSettingWorksheetsLogo from "../../../../images/new-images/goalseetingworksheet.png";

const calcWidth = window.innerWidth;
export class InstrumentWorkSheet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSideNav: SIDE_NAV_ITEMS[0].id,
            enableNotification: false,
            sidebarOpen: false,
            collapseID: null,
            InputFields: [],
            sharedWith: [],
            Note: {},
            getOrientationName: ''
        }
    }

    componentDidMount() {
        const orientationName = this.props.match.params.orientation__orientation_name;
        // dashboard edit goal setting api
        axios.post('http://api-uat.opptimise.in/api/v1/assessments/goal-setting/worksheets/attributes/list/'
            , { worksheet_id: 19 })
            .then((response) => {
                this.setState({
                    InputFields: response.data,
                    getOrientationName: orientationName
                })
            })
            .catch((error) => {
                console.error(error);
            });

        axios.get('http://api-uat.opptimise.in/api/v1/assessments/goal-setting/worksheets/shared_with/19/')
            .then((response) => {
                this.setState({
                    sharedWith: response.data
                })
            })
            .catch((error) => {
                console.error(error);
            });


        axios.post('http://api-uat.opptimise.in/api/v1/assessments/goal-setting/worksheets/weaksection/'
            , { user_assessment: 5952, orientation_id: 2 })
            .then((response) => {
                this.setState({
                    Note: response.data
                })
            })
            .catch((error) => {
                console.error(error);
            });
    }

    handleNotification = () => {
        this.setState({
            enableNotification: !this.state.enableNotification,
        });
    };

    onSetSidebarOpen = (open) => {
        this.setState({
            sidebarOpen: open,
        });
    };

    toggleCollapse = (collapseID) => {
        if (this.state.collapseID === collapseID) {
            this.setState({
                collapseID: null,
            });
        } else {
            this.setState({
                collapseID: collapseID,
            });
        }
    };
    render() {
        return (
            <div>
                <Navbar
                    enableNotification={this.state.enableNotification}
                    handleNotification={this.handleNotification}
                />
                <Sidebar
                    items={SIDE_NAV_ITEMS}
                    selectedSideNav={this.state.selectedSideNav}
                />
                <ResponsiveSidebar
                    items={SIDE_NAV_ITEMS}
                    selectedSideNav={this.state.selectedSideNav}
                    sidebarOpen={this.state.sidebarOpen}
                    onSetSidebarOpen={this.onSetSidebarOpen}
                />
                <Layout
                    headerIcon={GoalSettingWorksheetsLogo}
                    headerText={this.state.getOrientationName}
                    button='MANAGE WORKSHEET'
                >
                    {calcWidth <= 767 ? (
                        <ResponsiveWorksheetDetails
                            collapseID={this.state.collapseID}
                            toggleCollapse={this.toggleCollapse}
                            getOrientationName={this.state.getOrientationName}
                            InputFields={this.state.InputFields}
                            Note={this.state.Note}
                            sharedWith={this.state.sharedWith}
                        />
                    ) : (
                        <WorksheetDetails
                            getOrientationName={this.state.getOrientationName}
                            InputFields={this.state.InputFields}
                            Note={this.state.Note}
                            sharedWith={this.state.sharedWith}
                        />
                    )}
                </Layout>
            </div>
        )
    }
}

export default withRouter(InstrumentWorkSheet)



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/WorksheetDetails/index.jsx